import $ from "jquery"

// if ($.cookie('modal_shown') == null) {
// 	$.cookie('modal_shown', 'yes', { expires: 3, path: '/' });
// 	$('#dialog').dialog("open");        
// }


var twentyFourHoursInMs = 24 * 60 * 60 * 1000;
var lastTimestamp = Number(localStorage.getItem("last-showed-at"));
var currentTimestamp = Date.now();
if ((currentTimestamp - lastTimestamp) >= twentyFourHoursInMs) {
    localStorage.setItem("last-showed-at", currentTimestamp);
    setTimeout(function(){ 
		$('.popup').toggleClass('is-visible')
	}, 2000);
    // Display modal once again
}


$(document).keydown(function(e) {
	var code = e.keyCode || e.which;
	if ((code == 27) &&  $(".popup").hasClass('is-visible')) $(".popup").toggleClass('is-visible');
});

$('.popup__overlay').on('click', function(e) {
	e.preventDefault();
	$('.popup').toggleClass('is-visible');
});

$('.popup__close').on('click', function(e) {
	e.preventDefault();
	$('.popup').toggleClass('is-visible');
});
